import { NavLink, useLocation } from "react-router-dom";

const NavMenuItem = ({ title, icon, to, ...otherProps }) => {
  const location = useLocation();
  const { pathname } = location;
  const isActive = to === pathname;

  return (
    <NavLink
      to={to}
      className={`nav-link header__link ${
        isActive ? "header__link-active" : ""
      }`}
      {...otherProps}
    >
      {title} {icon}
    </NavLink>
  );
};

export default NavMenuItem;
